export default __webpack_public_path__ + "static/media/Poppins-Thin.9c2db7e9.eot";